var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCountry(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99995 14.9998C12.7574 14.9998 14.9999 12.7574 14.9999 9.99988C14.9999 7.24241 12.7574 4.99994 9.99995 4.99994C7.24248 4.99994 5 7.24241 5 9.99988C5 12.7574 7.24248 14.9998 9.99995 14.9998ZM9.99995 7.49991C11.3787 7.49991 12.4999 8.62115 12.4999 9.99988C12.4999 11.3786 11.3787 12.4999 9.99995 12.4999C8.62121 12.4999 7.49997 11.3786 7.49997 9.99988C7.49997 8.62115 8.62121 7.49991 9.99995 7.49991Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27501 24.7672C9.49251 24.9222 9.74625 24.9997 10 24.9997C10.2537 24.9997 10.5075 24.9222 10.725 24.7672C11.105 24.4985 20.0361 18.0498 19.9999 9.99989C19.9999 4.4862 15.5137 0 10 0C4.48631 0 0.000110046 4.4862 0.000110046 9.99364C-0.0361396 18.0498 8.89501 24.4985 9.27501 24.7672ZM10 2.49997C14.1362 2.49997 17.4999 5.86369 17.4999 10.0061C17.5262 15.5536 12.015 20.5348 10 22.1685C7.98627 20.5335 2.47383 15.5511 2.50008 9.99989C2.50008 5.86369 5.8638 2.49997 10 2.49997Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountry);
export default __webpack_public_path__ + "static/media/country.849a5b8e.svg";
export { ForwardRef as ReactComponent };